module.exports = __webpack_public_path__ + "static/media/applications.62109605.svg";